
import { Vue, Component } from 'vue-property-decorator';
import API from '@/lib/API';
import { currentUserHasPermission } from '@/helpers';
import { matchesAllWords } from '@/helpers/textSearch';
import { RuleArchiveEntry, RuleEvent } from '@/types';
import RuleArchivePayload from '@/components/rules/RuleArchivePayload.vue';

@Component({ components: { RuleArchivePayload } })
export default class RulesArchive extends Vue {
  loading = true

  searchFilter = ''

  entries: RuleArchiveEntry[] = []

  expanded: RuleArchiveEntry[] = []

  details: Record<number, RuleArchiveEntry> = {}

  headers = [
    { text: 'ID', value: 'id', width: '80px' },
    { text: 'Nome', value: 'name' },
    { text: 'Evento', value: 'eventCodename' },
    {
      text: 'Segnalata', value: 'flagged', width: '100px', sortable: false,
    },
    {
      text: '', value: 'actions', width: '140px', sortable: false,
    },
    { text: '', value: 'data-table-expand' },
  ]

  get filtered(): RuleArchiveEntry[] {
    return this.entries.filter(
      (e) => matchesAllWords(this.searchFilter, [e.id, e.name, e.searchText]),
    );
  }

  get events(): RuleEvent[] { return this.$store.getters.ruleEvents || []; }

  eventName(codename: string): string {
    const e = this.events.find((x) => x.codename === codename);
    return e ? e.name : codename;
  }

  hasPermission(codename: string): boolean { return currentUserHasPermission(codename); }

  async onExpanded({ item, value }: { item: RuleArchiveEntry; value: boolean }) {
    if (!value || this.details[item.id]) return;
    const entry = await API.getRulesArchiveEntry(item.id);
    if (entry instanceof Error) return;
    this.$set(this.details, item.id, entry);
  }

  recover(item: RuleArchiveEntry) {
    this.$router.push({ path: '/r/n', query: { archivio: String(item.id) } });
  }

  async created() {
    try {
      await this.$store.dispatch('fetchRuleMetadata');
      const list = await API.getRulesArchive();
      this.entries = Array.isArray(list) ? list : [];
    } finally {
      this.loading = false;
    }
  }
}
